
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Pie } from "vue-chartjs";
import { ChartDataSets } from "chart.js";

@Component({
  extends: Pie
})
export default class ExpensesCategoryGraphReport extends Mixins(Pie) {
  @Prop({ required: true }) labels!: string[];
  @Prop({ required: true }) expenses!: number[];

  colors: string[] = [
    "rgba(54, 162, 235, {0})",
    "rgba(255, 99, 132, {0})",
    "rgba(75, 192, 192, {0})",
    "rgba(255, 159, 64, {0})",
    "rgba(153, 102, 255, {0})",
    "rgba(255, 205, 86, {0})",
    "rgba(201, 203, 207, {0})"
  ];

  mounted() {
    // 印刷時に黒塗りになってしまうのを防ぐ
    this.addPlugin({
      id: "custom-background-color",
      beforeDraw: (chart: any) => {
        const { ctx } = chart;
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
      }
    });

    // custom tooltip
    this.addPlugin({
      id: "always-show-tooltip",
      afterDraw: (chart: any) => {
        const { ctx } = chart;
        ctx.save();

        const formatter = Intl.NumberFormat("ja-JP", {
          style: "currency",
          currency: "JPY"
        });
        const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
        const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

        chart.data.datasets.forEach((dataset: ChartDataSets, i: number) => {
          chart
            .getDatasetMeta(i)
            .data.forEach((datapoint: any, index: number) => {
              const { x, y } = datapoint.tooltipPosition();
              // Define an offset to move tooltips outward
              const offset = 35; // Adjust as needed
              const deltaX = x - centerX;
              const deltaY = y - centerY;
              const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

              // Calculate new positions
              const adjustedX = x + (deltaX / distance) * offset;
              const adjustedY = y + (deltaY / distance) * offset;

              const text = formatter.format(
                Number(chart.data.datasets[i].data[index])
              );
              const textWidth = ctx.measureText(text).width;

              // Draw tooltip text
              ctx.fillStyle = "white";
              ctx.fillText(text, adjustedX - textWidth / 2, adjustedY);
              ctx.restore();
            });
        });
      }
    });

    this.init();
  }

  @Watch("graphData")
  private init() {
    this.renderChart(this.graphData, {
      // 表示オプションを指定
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          usePointStyle: true
        },
        onClick(event: MouseEvent) {
          event.stopPropagation();
        }
      },
      title: {
        display: false
      },
      tooltips: {
        enabled: false
      }
    });
  }

  private setColor(graphItem?: any) {
    const index = graphItem.dataIndex;
    return this.colors[index % this.colors.length].replace(
      "{0}",
      String((10 * this.colors.length - index) / (10 * this.colors.length))
    );
  }

  private get graphData() {
    return {
      labels: this.labels,
      datasets: [
        {
          backgroundColor: this.setColor,
          data: this.expenses
        }
      ]
    };
  }
}
